import React from "react"
import { URLS } from "../../_config"
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs"
import Layout from "../layout"
import RightSettings from "./RightSettings"
import { Form } from "react-bootstrap"

const FundingRequest = () => {
    const [activeTab, setActiveTab] = React.useState(1)

    return <Layout>
        <div className="container-fluid" data-aos="fade-up" data-aos-duration="1000">

            <Breadcrumbs title="Submit Funding Request"
                breadcrumbs={{ Home: URLS.PROFILE, 'Funding Request': URLS.FUNDING.REQUEST_LIST, 'Submit': "#" }} />


            <div className="row">
                <div className="col-sm-2">
                    <div className="vr-tabs-panel">
                        <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                            <a className={`nav-link mb-2 ${activeTab == 1 && 'active'}`} onClick={() => setActiveTab(1)} id="home1" data-toggle="pill" href="#" role="tab" aria-controls="v-pills-home" aria-selected="true"><span className="tabs-number">1</span> Basic</a>
                            <a className={`nav-link mb-2 ${activeTab == 2 && 'active'}`} onClick={() => setActiveTab(2)} id="profile1" data-toggle="pill" href="#" role="tab" aria-controls="v-pills-profile" aria-selected="false"><span className="tabs-number">2</span> Loan info</a>
                        </div>
                    </div>
                </div>
                <div className="col-sm-10">
                    <div className="card">
                        <div className="card-body">
                            <div className="tab-content py-4 text-muted">
                                <div className={`tab-pane ${activeTab == 1 && 'active'}`} id="home1" role="tabpanel">
                                    <div className="mt-2">
                                        <label  >Loan Type ?</label>
                                        <div className="d-flex gap-20">
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Purchase"
                                                    name="loanType"
                                                    label={<strong>Purchase</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Refinance"
                                                    name="loanType"
                                                    label={<strong>Refinance</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Construction"
                                                    name="loanType"
                                                    label={<strong>Construction</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mt-2">
                                        <label >Why do you need the fund?</label>
                                        <textarea id="textarea" className="form-control" rows={3} placeholder="Please explain your requirment with in 500 character."></textarea>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Loan Type ?</label>
                                                <select id="formrow-inputState" className="form-control">
                                                    <option  >FHA</option>
                                                    <option>VA Loan</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="d-flex justify-content-end gap-2">
                                        <button className="btn btn-primary btn-lg">Next</button>
                                    </div> */}
                                    <div className="d-flex gap-15 mb-5">
                                        {/* <button type="submit" className="btn btn-outline-danger w-md btn-lg px-5" > previous </button> */}
                                        <button type="submit" className="btn btn-primary w-md btn-lg px-5" >  Next </button>
                                    </div>
                                </div>
                                <div className={`tab-pane ${activeTab == 2 && 'active'}`} id="profile1" role="tabpanel">
                                    <h3 className="font-size-16">Scenario Request for Purchase</h3>

                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Purchase Price ($)</label>
                                                <input type="text" className="form-control" id="formrow-inputCity" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Down Payment (%)</label>
                                                <input type="text" className="form-control" id="formrow-inputCity" />
                                            </div>
                                        </div>

                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label >Loan Amount ($)</label>
                                                <input type="text" className="form-control" id="formrow-inputZip" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-2">
                                        <label  >Occupancy Type ?</label>
                                        <div className="d-flex gap-20">
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Primary"
                                                    name="OccupancyType"
                                                    label={<strong>Primary</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Second"
                                                    name="OccupancyType"
                                                    label={<strong>Second</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                            <div className="custom-control custom-radio custom-radio-primary radio-check-btn mb-3">
                                                <Form.Check
                                                    type="radio"
                                                    id="Investment"
                                                    name="OccupancyType"
                                                    label={<strong>Investment</strong>}
                                                    className="form-check-input"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label >Property Type</label>
                                                <select id="formrow-inputState" className="form-control">
                                                    <option  >Choose...</option>
                                                    <option>...</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Credit Score</label>
                                                <select id="formrow-inputState" className="form-control">
                                                    <option  >Choose...</option>
                                                    <option>...</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Property Street Address (Optional)</label>
                                                <input type="text" className="form-control" id="formrow-inputCity" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label >Property City</label>
                                                <input type="text" className="form-control" id="formrow-inputCity" />
                                            </div>
                                        </div>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label  >Property State?</label>
                                                <select id="formrow-inputState" className="form-control">
                                                    <option  >Choose...</option>
                                                    <option>...</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="d-flex justify-content-end gap-2">
                                        <button className="btn btn-primary btn-lg">Back</button>
                                        <button className="btn btn-success btn-lg">Submit</button>
                                    </div> */}
                                    <div className="d-flex gap-15 mb-5">
                                        <button type="submit" className="btn btn-outline-danger w-md btn-lg px-5" > previous </button>
                                        <button type="submit" className="btn btn-primary w-md btn-lg px-5" >  Submit </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </Layout>
}
export default FundingRequest